import { Directive } from '@angular/core';
import {  AbstractControl,  NG_VALIDATORS, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[noSpaces]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NoWhitespaceDirective, multi: true }],
  standalone: false
})
export class NoWhitespaceDirective {

  private valFn = NoWhitespaceValidator();
  validate(control: AbstractControl): { [key: string]: any } | null {
      return this.valFn(control);
  }

}

export function NoWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let inputValue = '';
    if (control !== null && control !== undefined && control.value !== null && control.value !== undefined) {
      inputValue = control.value.toString();
    }
    const isWhitespace = inputValue.trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': 'value is only whitespace' };
  };
}

